/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'wrench': {
    width: 16,
    height: 16,
    viewBox: '0 0 18.78 18.78',
    data: '<g data-name="图层 2"><path pid="0" d="M16 18.78a2.77 2.77 0 01-2-.78l-5-5a6.82 6.82 0 01-7-1.5A6.65 6.65 0 01.55 4.06a.5.5 0 01.81-.16l3.59 3.58a.58.58 0 00.8 0l1.73-1.73a.57.57 0 000-.8L3.9 1.36a.5.5 0 01.16-.81A6.7 6.7 0 0113 9l5 5a2.79 2.79 0 01-2 4.77zm-6.85-6.9a.5.5 0 01.35.15l5.23 5.23a1.84 1.84 0 002.54 0 1.8 1.8 0 000-2.54L12 9.5a.5.5 0 01-.06-.5 5.7 5.7 0 00-6.77-7.78l3 3a1.57 1.57 0 010 2.22L6.46 8.19a1.6 1.6 0 01-2.22 0l-3-3a5.65 5.65 0 001.51 5.62 5.81 5.81 0 006.22 1.13.5.5 0 01.17-.06z" _fill="#c4c4c4" data-name="图层 1"/></g>'
  }
})
